import React, { Component } from "react";
import { connect } from "react-redux";
import ReactTable from "react-table";
import "react-table/react-table.css";

class Report extends Component {
  render() {
    let applicants = this.props.applicants;
    return (
      <div className="mt3 pb4 pa3">
        <h1 className="tc mb2">Selected Candidates</h1>
        <p className="mb1">
          Report of candidates that meet selection criterium.
        </p>
        <ReactTable
          className="-highlight -striped bg-white"
          data={applicants}
          defaultSorted={[
            {
              id: "age",
              desc: true
            }
          ]}
          columns={[
            {
              columns: [
                {
                  Header: "Firstname",
                  accessor: "firstname"
                },
                {
                  Header: "Lastname",
                  accessor: "lastname"
                },
                {
                  Header: "Referecen id",
                  accessor: "id"
                },
                {
                  Header: "Age",
                  accessor: "age"
                },
                {
                  Header: "Highest Qualification",
                  accessor: "highestQualification"
                },
                {
                  Header: "Course",
                  accessor: "course"
                },
                {
                  Header: "Grade",
                  accessor: "grade"
                },
                {
                  Header: "Grduation Date",
                  accessor: "grduationDate"
                },
                {
                  Header: "State",
                  accessor: "stateOfOrigin"
                },
                {
                  Header: "Experience (years)",
                  accessor: "yearsOfExperience"
                },
                {
                  Header: "Email",
                  accessor: "email"
                },
                {
                  Header: "Phone number",
                  accessor: "phonenumber"
                },
                {
                  Header: "Other Qualifications",
                  accessor: "otherQualifications"
                },
                {
                  Header: "Experience (description)",
                  accessor: "experienceDescription"
                }
              ]
            }
          ]}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  applicants: state.selectedApplicants
});

export default connect(mapStateToProps)(Report);



// WEBPACK FOOTER //
// ./src/pages/report.js